import {
	Pagination,
	PaginationContent,
	PaginationItem,
	PaginationNext,
	PaginationPrevious,
} from '@playbooks/ui/components/pagination';

const SliderPagination = ({ meta, params, setParams }) => {
	// Computed
	const page = meta?.page || 1;
	const totalPages = Math.ceil(meta?.totalRecords / (meta?.pageSize || 10000000)) || 1;

	// Render
	return (
		<Pagination className='justify-start'>
			<PaginationContent>
				<PaginationItem>
					<PaginationPrevious disabled={page < 1} onClick={() => setParams({ ...params, page: page - 1 })} />
				</PaginationItem>
				<span className='text-foreground-body text-sm font-medium p-2'>
					{page} of {totalPages}
				</span>
				<PaginationItem>
					<PaginationNext disabled={page > totalPages - 1} onClick={() => setParams({ ...params, page: page + 1 })} />
				</PaginationItem>
			</PaginationContent>
		</Pagination>
	);
};

export { SliderPagination };
